import { Route, Routes } from 'react-router-dom';
import { useCompanyContext } from '../../context/CompanyContext';
import ErrorBoundary from '../../HOCs/ErrorBoundary';
import SystemError from '../../components/messages/SystemError';
import Policy from '../../pages/Insurance/Policy';
import checkPermissions from '../../HOCs/CheckPermissions';
import { reportsPerSection } from '../../../utils/rolesConst';
import Claim from '../../pages/Insurance/Claim';
import Dashboard from '../../pages/Insurance/Dashboard';
import Form from '../../pages/Insurance/Forms';
import TabsNavBar from '../../features/system/navbar/TabsNavBar';
import { SYSTEM_OPTIONS } from '../../features/system/navbar/options';
import InsuranceFormRoutes from './forms';

const InsuranceRoutes = () => {
  const { selectedCompany } = useCompanyContext();

  const PolicyProtected = checkPermissions({
    sectionsToAccess: reportsPerSection['policy'],
    Children: Policy,
  });

  const ClaimProtected = checkPermissions({
    sectionsToAccess: reportsPerSection['claim'],
    Children: Claim,
  });

  return (
    <div>
      <div className="mx-2 overflow-x-auto scrollbarStyled">
        <TabsNavBar
          options={SYSTEM_OPTIONS.insurance}
          rootPath={`/insurance`}
        />
      </div>
      {!!selectedCompany && (
        <div className="dashboardBG">
          <ErrorBoundary fallBack={<SystemError />}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/policies" element={<PolicyProtected />} />
              <Route path="/claims" element={<ClaimProtected />} />
              <Route path="/new" element={<Form />} />
              <Route path="/new/*" element={<InsuranceFormRoutes />} />
            </Routes>
          </ErrorBoundary>
        </div>
      )}
    </div>
  );
};

export default InsuranceRoutes;
